export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عبر تطبيق المصادقة"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-DZ": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "ar-EG": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عبر تطبيق المصادقة"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-LB": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "ar-MA": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "ar-SA": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عبر تطبيق المصادقة"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        }
      },
      "ar-SY": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "ar-TN": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "bg-BG": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване чрез приложение за удостоверяване"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        }
      },
      "bs-BA": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kôd"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za provjeru autentičnosti putem aplikacije za provjeru autentičnosti"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        }
      },
      "cs-CZ": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód prostřednictvím ověřovací aplikace"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        }
      },
      "da-DK": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskode"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskode via godkendelsesapp"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        }
      },
      "de-DE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per Authentifizierungs-App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-AT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per Authentifizierungs-App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-CH": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungscode per Authentifizierungs-App"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        }
      },
      "de-LU": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "el-GR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω εφαρμογής ελέγχου ταυτότητας"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        }
      },
      "el-CY": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω εφαρμογής ελέγχου ταυτότητας"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        }
      },
      "en-GB": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by authentication app"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        }
      },
      "en-IE": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "en-US": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by authentication app"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        }
      },
      "es-ES": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación a través de la aplicación de autenticación"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        }
      },
      "et-EE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood autentimisrakenduse kaudu"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        }
      },
      "fi-FI": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi todennussovelluksen kautta"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        }
      },
      "fr-BE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification via l'application d'authentification"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "fr-CH": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "fr-FR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification via l'application d'authentification"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "fr-LU": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification via l'application d'authentification"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        }
      },
      "ga-IE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód fíordheimhnithe"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód fíordheimhnithe trí aip fíordheimhnithe"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        }
      },
      "he-IL": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות באמצעות אפליקציית אימות"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        }
      },
      "hi-IN": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "hr-HR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za provjeru autentičnosti putem aplikacije za provjeru autentičnosti"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        }
      },
      "hu-HU": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő kód"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítési kód a hitelesítési alkalmazáson keresztül"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        }
      },
      "it-CH": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "it-IT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione tramite app di autenticazione"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        }
      },
      "ja-JP": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コード"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリによる認証コード"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        }
      },
      "ko-KR": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "lt-LT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas per autentifikavimo programą"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        }
      },
      "lv-LV": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods, izmantojot autentifikācijas lietotni"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        }
      },
      "mt-MT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta' Awtentikazzjoni"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta 'awtentikazzjoni permezz ta' app ta 'awtentikazzjoni"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        }
      },
      "nb-NO": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "nl-BE": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "nl-NL": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatie code"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode via authenticatie-app"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        }
      },
      "pl-PL": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod weryfikacyjny"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający za pośrednictwem aplikacji uwierzytelniającej"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        }
      },
      "pt-PT": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de Autenticação"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação via aplicativo de autenticação"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        }
      },
      "ro-RO": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cod de autentificare"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cod de autentificare prin intermediul aplicației de autentificare"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        }
      },
      "ru-RU": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации через приложение аутентификации"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        }
      },
      "sk-SK": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód prostredníctvom autentifikačnej aplikácie"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        }
      },
      "sl-SI": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti prek aplikacije za preverjanje pristnosti"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        }
      },
      "sv-SE": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod via autentiseringsapp"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        }
      },
      "th-TH": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "tr-CY": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama uygulaması aracılığıyla kimlik doğrulama kodu"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        }
      },
      "tr-TR": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama uygulaması aracılığıyla kimlik doğrulama kodu"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        }
      },
      "uk-UA": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код Аутентифікації"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код автентифікації через додаток автентифікатора"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Підтвердити"])}
        }
      },
      "vi-VN": {
        "unlockWith": {
          
        },
        "authenticatorOTPForm": {
          
        },
        "confirmCode": {
          
        }
      },
      "zh-CN": {
        "unlockWith": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码"])}
        },
        "authenticatorOTPForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过身份验证应用程序的身份验证代码"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        }
      }
    }
  })
}
